import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  transform(value: string | null | undefined, length = 50, clamp = '…'): string {
    if (!value) return '';
    if (value.length <= length) return value;
    return value.slice(0, Math.max(0, length - clamp.length)) + clamp;
  }
}

// Usage: {{ company.description | truncate:120 }}